import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { generate } from 'shortid';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import ValidationBlock from './ValidationBlock';

import './FieldGroup.css';

const FieldGroup = observer(
class FieldGroup extends Component {
  constructor(props) {
    super(props);
    this.ids = {
      control: generate(),
      popover: generate(),
    };
    this.control = null;
  }

  componentDidMount() {
    const {
      focus,
    } = this.props;

    if (focus && this.control) {
      const dom = ReactDOM.findDOMNode(this.control);
      dom.blur && dom.blur();
      setTimeout(() => {
        dom.focus && dom.focus();
        dom.select && dom.select();
      }, 350);
    }
  }

  render() {
    let {
      id = this.ids.control,
      formStyle,
      label,
      help,
      validation,
      validationState,
      hideControl = false,
      focus,
      ...data
    } = this.props;

    let control = (<FormControl ref={c => {this.control = c}} {...data} />);

    if (validation) {
      let overlayParams = {
        trigger: "focus",
        placement: "top",
      }
      let overlay = (
        <Popover id={this.ids.popover}>
          <ValidationBlock validation={validation} />
        </Popover>
      );
      // set overrides
      validationState = validation.getState();
      control = (
        <OverlayTrigger overlay={overlay} {...overlayParams}>
          {control}
        </OverlayTrigger>
      )
    }
    return (
      <FormGroup controlId={id} style={formStyle} validationState={validationState}>
        {hideControl || <ControlLabel>{label}</ControlLabel>}
        {hideControl || control }
        {help && <HelpBlock className="help-block-text">{help}</HelpBlock>}
      </FormGroup>
    );
  }
});

export default FieldGroup;


// WEBPACK FOOTER //
// ./src/components/FieldGroup/FieldGroup.js